export const MENU = [
  {
    id: "salate",
    name: "Salate",
    items: [
      { name: "Bauernsalat", price: "10,00", desc: "Grüner Salat, Tomaten, Paprika, Gurken, Peperoni, Feta-Käse, Oliven, Zwiebeln", tag: "Vegetarisch" },
      { name: "Bauernsalat pur", price: "8,00", desc: "Ohne Feta-Käse, ohne Oliven", tag: "Vegan" },
      { name: "Thunfischsalat", price: "11,00", desc: "Grüner Salat, Tomaten, Paprika, Gurken, Peperoni, Thunfisch" },
      { name: "Chef Salat", price: "11,50", desc: "Grüner Salat, Tomaten, Paprika, Gurken, Gouda-Käse, Kochschinken, Ei, Mais" },
      { name: "Tsolias Salat", price: "12,50", desc: "Grüner Salat, Tomaten, Paprika, Gurken, Gyros-Fleisch" },
      { name: "Zigeunersalat", price: "4,50", desc: "Krautsalat mit Möhrenstreifen, selbstgemacht", tag: "Vegan" },
      { name: "Bohnensalat", price: "4,50", tag: "Vegetarisch" },
      { name: "Gurkensalat", price: "4,50" },
      { name: "Nudelsalat", price: "4,50", desc: "Ohne Wurst", tag: "Vegetarisch" },
      { name: "Rote Bete", price: "4,50", tag: "Vegan" },
      { name: "Tzatziki", price: "4,50", desc: "Selbstgemacht" },
      { name: "Portion Peperoni", price: "4,50", tag: "Vegan" },
      { name: "Krautsalat", price: "4,50", desc: "Selbstgemacht", tag: "Vegan" },
      { name: "Pita Salat", price: "6,00", desc: "Mit Tzatziki oder Joghurt", tag: "Vegetarisch" },
      { name: "Pita Saganaki", price: "7,50", desc: "Pita Brot mit Krautsalat und Saganaki", tag: "Vegetarisch" },
      { name: "Saganaki", price: "4,50", desc: "Gebackener Käse" },
      { name: "Feta Käse", price: "4,50" },
    ],
  },
  {
    id: "gyros",
    name: "Gyros",
    items: [
      { name: "Gyros Komplett Groß", price: "14,00", desc: "Pommes, Salat und Tzatziki" },
      { name: "Gyros Pommes Groß, Salat o. Tzatziki", price: "13,00" },
      { name: "Gyros Salat und Tzatziki Groß", price: "13,00" },
      { name: "Gyros Pommes Groß", price: "11,50" },
      { name: "Gyros Salat oder Tzatziki Groß", price: "11,50" },
      { name: "Gyros-Fleisch pro kg", price: "29,00" },
      { name: "Gyros Family Box", price: "59,00", desc: "Ab 4 Personen — Gyros, Fritten, Salat und Tzatziki getrennt verpackt" },
      { name: "Portion Gyros-Fleisch", price: "9,50" },
    ],
  },
  {
    id: "gyros-spezial",
    name: "Gyros Spezial",
    items: [
      { name: "Pita-Pizza", price: "11,00", desc: "Gyros Pita mit Gouda-Käse überbacken" },
      { name: "Gyros Überbacken", price: "14,50", desc: "Mit Tomatensauce und Gouda-Käse überbacken" },
      { name: "Gyros Kritharaki", price: "14,50", desc: "Mit griech. Nudelreis und Gouda-Käse überbacken" },
      { name: "Gyros Überbacken / Kritharaki Komplett", price: "17,00", desc: "Mit Pommes und Salat" },
      { name: "Gyros Pita", price: "8,00" },
      { name: "Doppelte Gyros Pita", price: "12,80" },
      { name: "Gyros im Fladenbrot", price: "8,00" },
      { name: "Tsolias Tüte", price: "12,00", desc: "Gyros im Fladenbrot, dazu Pommes und ein 330ml Getränk" },
      { name: "Hamburger Gyros", price: "7,50" },
    ],
  },
  {
    id: "grill",
    name: "Vom Grill",
    items: [
      { name: "Grillteller", price: "17,00", desc: "Gyros, 1 Souvlaki, 1 Bifteki, Pommes, Salat oder Tzatziki" },
      { name: "Souvlaki-Teller", price: "16,50", desc: "3 Fleischspieße, Pommes, Salat oder Tzatziki" },
      { name: "Hähnchenfilet", price: "16,50", desc: "Mit Pommes und Salat" },
      { name: "Souvlaki", price: "4,00", desc: "Aus Schweinefleisch, pro Stück" },
      { name: "Cevapcici", price: "13,00", desc: "Aus Rindfleisch, mit Pommes und Salat" },
      { name: "Bifteki", price: "9,00", desc: "Frikadellen griechischer Art, aus gemischtem Hackfleisch (Schwein/Rind), Portion" },
      { name: "Bifteki Komplett", price: "14,00", desc: "Mit Pommes, Salat und Tzatziki" },
    ],
  },
  {
    id: "schnitzel",
    name: "Schnitzel",
    items: [
      { name: "Schnitzel Wiener Art", price: "12,00", desc: "Mit Pommes und Salat" },
      { name: "Jägerschnitzel mit Pommes und Salat", price: "13,00" },
      { name: "Zigeunerschnitzel mit Pommes und Salat", price: "13,00" },
      { name: "Krüstchen", price: "13,50", desc: "Mit Pommes und Salat" },
      { name: "Jägerschnitzel mit Pommes", price: "12,00" },
      { name: "Jägerschnitzel mit Salat", price: "11,50" },
      { name: "Zigeunerschnitzel mit Pommes", price: "11,50" },
      { name: "Zigeunerschnitzel mit Salat", price: "11,50" },
      { name: "Jägerschnitzel", price: "8,50", desc: "Nur Schnitzel" },
      { name: "Zigeunerschnitzel", price: "8,50", desc: "Nur Schnitzel" },
    ],
  },
  {
    id: "sonstiges",
    name: "Sonstiges",
    items: [
      { name: "Currywurst", price: "4,50" },
      { name: "Jägerwurst", price: "4,50" },
      { name: "Zigeunerwurst", price: "4,50" },
      { name: "Currywurst mit Pommes", price: "7,50" },
      { name: "Jägerwurst mit Pommes", price: "7,50" },
      { name: "Zigeunerwurst mit Pommes", price: "7,50" },
      { name: "Bratwurst mit Pommes", price: "6,50" },
      { name: "Bratwurst mit Senf", price: "4,00" },
    ],
  },
  {
    id: "burger",
    name: "Burger",
    items: [
      { name: "Hamburger", price: "7,50" },
      { name: "Cheeseburger", price: "8,00" },
      { name: "Hamburger Menü", price: "10,60", desc: "Mit Pommes und 1 Getränk" },
      { name: "Cheeseburger Menü", price: "11,10", desc: "Mit Pommes und 1 Getränk" },
    ],
  },
  {
    id: "beilagen",
    name: "Beilagen",
    items: [
      { name: "Pommes Frites", price: "3,50" },
      { name: "Doppelte Portion Pommes Frites", price: "5,50", tag: "Vegetarisch" },
      { name: "Dolmadakia", price: "1,00", desc: "Mit Reis gefüllte Weinblätter, pro Stück", tag: "Vegan" },
      { name: "Pita Brot", price: "1,10", desc: "Pro Stück", tag: "Vegetarisch" },
      { name: "Kroketten", price: "4,00", tag: "Vegetarisch" },
      { name: "Kritharaki", price: "4,00" },
    ],
  },
  {
    id: "sossen",
    name: "Sossen",
    items: [
      { name: "Ketchup", price: "0,80" },
      { name: "Curry-Ketchup", price: "0,80" },
      { name: "Mayonnaise", price: "0,80", desc: "50% Pflanzenöl" },
      { name: "Jägersauce", price: "1,20" },
      { name: "Schaschliksauce", price: "1,20" },
      { name: "Zigeunersauce", price: "1,20" },
    ],
  },
  {
    id: "getraenke",
    name: "Getränke",
    items: [
      { name: "Coca Cola 0,33l / 0,5l", price: "3,00 / 4,00" },
      { name: "Cola Light 0,33l / 0,5l", price: "3,00 / 4,00" },
      { name: "Cola Zero 0,33l / 0,5l", price: "3,00 / 4,00" },
      { name: "Fanta 0,33l / 0,5l", price: "3,00 / 4,00" },
      { name: "Sprite 0,33l / 0,5l", price: "3,00 / 4,00" },
      { name: "Mezzo Mix 0,33l / 0,5l", price: "3,00 / 4,00" },
      { name: "Lift 0,33l / 0,5l", price: "3,00 / 3,30" },
      { name: "Wasser 0,25l / 0,5l", price: "3,00 / 4,00" },
      { name: "Krombacher Fassbrause 0,33l", price: "3,00" },
      { name: "Krombacher Weizen alkoholfrei 0,5l", price: "4,80" },
      { name: "Saft 200ml", price: "3,00" },
      { name: "Vita Malz 0,33l", price: "3,00" },
    ],
  },
  {
    id: "kaffee",
    name: "Kaffee",
    groups: [
      {
        label: "Heiss",
        items: [
          { name: "Espresso", price: "2,80" },
          { name: "Espresso Macchiato", price: "3,00" },
          { name: "Cappuccino", price: "3,50" },
          { name: "Latte Macchiato", price: "4,20" },
          { name: "Schokolade", price: "4,00" },
          { name: "Tee", price: "3,00" },
          { name: "Kaffee", price: "3,00" },
        ],
      },
      {
        label: "Kalt",
        items: [
          { name: "Freddo Espresso", price: "3,50" },
          { name: "Freddo Cappuccino", price: "4,00" },
          { name: "Frappé", price: "4,00" },
          { name: "Schokolade", price: "4,00" },
        ],
      },
    ],
  },
];

export const PHONE = "0271 21529";
export const PHONE_LINK = "tel:+4927121529";
export const ADDRESS = "Spandauer Str. 1, 57072 Siegen";
export const MAPS_LINK = "https://www.google.com/maps/search/?api=1&query=Spandauer+Str.+1,+57072+Siegen";
export const MENU_LINK = "https://m.tsolias.de";

export const HOURS = [
  { day: "Montag", time: "11:30 – 21:00" },
  { day: "Dienstag", time: "Ruhetag", closed: true },
  { day: "Mittwoch", time: "11:30 – 21:00" },
  { day: "Donnerstag", time: "11:30 – 21:00" },
  { day: "Freitag", time: "11:30 – 22:00" },
  { day: "Samstag", time: "11:30 – 22:00" },
  { day: "Sonntag", time: "11:30 – 21:00" },
];

export const isOpenNow = () => {
  const now = new Date();
  const d = now.getDay();
  if (d === 2) return false;
  const close = d === 5 || d === 6 ? 22 : 21;
  const t = now.getHours() + now.getMinutes() / 60;
  return t >= 11.5 && t < close;
};
